
import { FaIndustry, FaBullseye, FaCheckCircle } from "react-icons/fa";

const AboutSection = () => {
  return (
    <section id="about" className="lp-about">
      <div className="lp-about__inner">
        <div className="lp-section-header">
          <span className="lp-section-tag">About the Platform</span>
          <h2>A Simple Way to Manage All Your Assets</h2>
          <p>
            A complete asset management platform that helps teams of any size
            track, maintain, and get the most out of their equipment and resources.
          </p>
        </div>

        <div className="lp-about__grid">
          <div className="lp-about__card">
            <div className="lp-about__icon-wrap">
              <FaIndustry />
            </div>
            <h3>Works for Any Team</h3>
            <p>
              No matter what kind of assets you manage — this platform adapts to
              your workflow with flexible categories, custom fields, and
              maintenance schedules that fit your needs.
            </p>
          </div>

          <div className="lp-about__card">
            <div className="lp-about__icon-wrap">
              <FaBullseye />
            </div>
            <h3>Our Goal</h3>
            <p>
              To help you stay on top of every asset, prevent unexpected
              breakdowns, and keep your operations running smoothly with clear
              visibility and smart alerts.
            </p>
          </div>

          <div className="lp-about__card">
            <div className="lp-about__icon-wrap">
              <FaCheckCircle />
            </div>
            <h3>Why Choose Us?</h3>
            <ul className="lp-about__list">
              <li>Role-based access for your entire team</li>
              <li>Automated maintenance scheduling</li>
              <li>Live dashboards with clear analytics</li>
              <li>Warranty and stock-level alerts</li>
              <li>Full task and work-order tracking</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
